import "./index.css";

import { useEffect } from "react";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { useRoute, navigate } from "./hooks/useRoute";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { HomePage } from "./pages/HomePage";

const AUTH_PAGES = ["/login", "/register", "/forgot"];

function Router() {
  const route = useRoute();
  const { isAuthed } = useAuth();

  // 未登录访问首页 → 登录页；已登录访问认证页/根路径 → 持仓页（重定向不产生历史记录）
  useEffect(() => {
    if (!isAuthed && !AUTH_PAGES.includes(route)) {
      navigate("/login", true);
    } else if (isAuthed && (AUTH_PAGES.includes(route) || route === "/")) {
      navigate("/holding", true);
    }
  }, [route, isAuthed]);

  if (route === "/register") return <RegisterPage />;
  if (route === "/forgot") return <ForgotPasswordPage />;
  if (route === "/login") return <LoginPage />;
  return <HomePage />;
}

export function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
